export default class Locale_ResourcePicker { 
	HeaderText = {
		ResourceDelegation: "Resource Delegation",
		ResourcePicker: "Resource Picker",
	}
	SuggestedResources: string = "Suggested Resources";
	ResourcePickerSuggestionsAvailable: string = "Resource Picker Suggestions available";
	RecentlyUsedResources: "Recently used resources";
}